import { useAuth } from '../../../../store/AuthContext/AuthContext';
import '../../../pages/common/header/MainHeader.scss';

export const ProjectGroup = (props: { isProject: boolean }) => {
	const { projectGroup } = useAuth();
	const label = props.isProject ? 'Proyecto' : 'Grupo de Google';
	const value = props.isProject ? projectGroup.project : projectGroup.groupName;
	const isAllGroups = !props.isProject && value === 'Todos los Grupos';

	return (
		<div
			className={[
				'header-scope-select',
				'header-scope-select--active',
				isAllGroups ? 'header-scope-select--all-groups' : '',
			].filter(Boolean).join(' ')}
			style={{
				minWidth: props.isProject ? undefined : 140,
				paddingBottom: 15,
			}}
		>
			<div
				style={{
					minHeight: 32,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-start',
					padding: '0 11px',
					fontSize: 13,
					fontWeight: 700,
					color: '#0f172a',
					whiteSpace: 'nowrap',
					maxWidth: 280,
					overflow: 'hidden',
					textOverflow: 'ellipsis',
				}}
				title={value}
			>
				{value || '—'}
			</div>
			<small className='header-scope-select__label'>{label}</small>
		</div>
	);
};
